<template>
    <main>
        <header>
            <div class="container">
                <img src="@/assets/img/logo.svg">
                <h1>Papelaria Beira Mar</h1>
                <p>Comércio de Material Escolar, de Escritório, de Informática, Presentes, Artesanato, Descartáveis, Festa e Serviços de Cópia, Impressão, Encadernação, Plastificação e Confecção de Carimbos. </p>
            </div>
        </header>
        <section id="servicos">
            <div class="container">
                <!-- <h2>Serviços</h2> -->
                <div class="cards">
                    <div class="card">
                        <i class="bi bi-printer"></i>
                        <h3>Impressão</h3>
                        <p>Aceitamos arquivos por Whatsapp e E-mail. Temos papel fotográfico.</p>
                    </div>
                    <div class="card">
                        <i class="bi bi-copy"></i>
                        <h3>Cópias</h3>
                        <p>Preta ou colorida, disponibilizamos diversas gramaturas.</p>
                    </div>
                    <div class="card">
                        <i class="bi bi-archive"></i>
                        <h3>Plastificação</h3>
                        <p>Proteja seus documentos com plastificação de alta qualidade e durabilidade.</p>
                    </div>
                    <div class="card">
                        <i class="bi bi-postage-heart"></i>
                        <h3>Carimbos</h3>
                        <p>Carimbos personalizados com rapidez e precisão, ideais para empresas e uso pessoal.</p>
                    </div>
                    <div class="card">
                        <i class="bi bi-journal-text"></i>
                        <h3>Encadernação</h3>
                        <p>Dê acabamento profissional aos seus trabalhos com encadernação espiral ou capa dura.</p>
                    </div>
                    <div class="card">
                        <i class="bi bi-upc-scan"></i>
                        <h3>Digitalização</h3>
                        <p>Digitalize documentos e fotos com alta qualidade e receba os arquivos em formato PDF ou imagem.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="produtos">
            <div class="container">
                <h2>Produtos</h2>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p>Aqui você encontra material escolar, cadernos, cadernetas, agendas, planers, calendários de modelos variados, fichários, pastas... Confira alguns exemplos abaixo.</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Presentes & Festas</strong><br> cartões com mensagens, mochilas, diário com cadeado, canetas finas, necessaires, album de fotografias, organizador de mesa, embrulhos, caixas e sacolas de presentes em formas, tamanhos, modelos e estampas variadas, fitas, laços, velas,  elástico decorativo, faixas "feliz aniversário" e "parabéns´", baralhos, talões de bingo, dados, bandeira de festa junina, talheres descartáveis, espeto para churrasco, confete, lança confete, bomba de encher balão, balões, bola de gude, bola de ping pong, Kimeleca slime, Bolsa Vintage, cambucas de times, canecas temáticas, carteiras, chaveiros temáticos, cofrinhos temáticos, cooler temático, copos temáticos, dominós,  garrafinhas individuais (de 350 a 750ml).</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Escritório</strong><br> porta lápis, bloco de notas, bloco flip chart,  Post-it, grampeadores, caixas suspensas, caixas organizadoras, cadeados, chaveiros com placa para identificação, calculadoras, caneta com suporte de metal, contador analógico de 4 dígitos, crachá , extrator de grampos, etiquetas, fichários, garrafinhas individuais de (350 a 750ml), índice telefônico de mesa, lacres, livros ata, organizador de documentos, perfurador, prancheta.</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Canetas</strong><br> canetas hidrográficas, caneta pincel dual brush, caneta energel secagem rápida, canetas esferográficas, canetas em gel, caneta de ponta ultra fina, caneta para tablet, caneta permanente, caneta marcador pigment liner, caneta com a profissão escrita, caneta tinteiro, marca texto, marcador de retroprojetor e CD.</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Informática & Elétricos</strong><br> Adaptadores para celulares, mouse pads, mouses, teclados, cartuchos de tinta, cabos: de rede, de audio, de dados, de força, HDMI, USB, de TV, VGA... Pilhas, bateria, capas para: celular , gabinete, monitor, Ipad... fita isolante, fone de ouvido, headset, lanternas, pen drive, web cam.</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Armarinho</strong><br> agulhas, alfinetes, tesouras, fitas métrica, linhas coloridas, abridor de casa, dedal, réguas, esquadro, papel para molde,  giz branco e colorido, caixa para organizar bobinas ou linhas, lápis, borrachas, canetas, tintas e canetas de tecidos.</p>
                </div>
                <div class="produto">
                    <img src="@/assets/img/produtos/0f15f1f5-83bf-4fd5-939f-b1c99072de6b.jpg" alt="">
                    <p><strong>Artesanato</strong><br> argilas, blocos para desenho, aquarela, guache, nankin... pincéis, bolas: de gude, de isopor, de ping pong, caderno de cartografia, argola de chaveiro, Colas: branca, colorida, com gliter, para madeira, para isopor, para tecido... espeto para churrasco, palito de sorvete, estilete, gliter, massa de modelar, massa de EVA, pena colorida, pistola de cola quente, tela de pintura.</p>
                </div>
            </div>
        </section>
        <section id="decoy">
            <div class="container">
                <h3>Temos ainda: ímãs, caixas organizadoras, adesivos, balança de precisão, boullet Journal, canivete, capa de chuva, compasso, leitor de código de barras, livros de caligrafia temáticos e novidades.</h3>
            </div>
        </section>
        <section id="contato">
            <div class="container">
                <h2>Contato</h2>
                <a href="https://wa.me/552125535455">Envie uma mensagem no whatsapp</a>
                <p>Praia Botafogo 340 - LJ L - Botafogo - Rio de Janeiro - RJ- CEP: 22250-040 - Brasil</p>
                <p>Entrada pela Rua Visconde de Ouro Preto</p>
                <p>(21) 2553-5455 | (21) 2553-5467 (Fax)</p>
                <h3>Horário de Funcionamento</h3>
                <p>Seg a Sex 09-18</p>
                <p>Sab 09-13</p>
            </div>
        </section>
    </main>
</template>
<script>
import 'bootstrap-icons/font/bootstrap-icons.css';
export default {
    name: 'App',
}
</script>

<style lang="less">
main{
    overflow: hidden; .bceu;
    header{
        .tc; padding: 100px 0; .bbranco;
        img{ width: 100px; }
        h1{ .m0; .mb05; .w400; .t56; .cceu; .parkinsans; .lh120; }
        p{ max-width: 560px; margin: auto; .lh160; .t18; }
        @media (min-width: 768px) {
            img{ width: 130px; }
            h1{ .t72; }
        }
    }
    #servicos{
        padding: 0 0 50px; margin-top: 80px; .bareia; position: relative;
        border-radius: 0 0 150px 150px;
        &::before{
            position: absolute; left: -25%; top: -120px; width: 150%; height: 120px;
            .bagua; content: ''; border-radius: 90% 90% 0 0;
        }
        &::after{
            position: absolute; left: 0; top: -80px; width: 100%; height: 80px;
            .bareia; content: ''; border-radius: 100% 100% 0 0;
        }
        .cards{
            display: grid; grid-template-columns: 1fr; gap: 20px; position: relative; z-index: 20;
            .card{
                background: lighten(@areia, 12%); .p20; .rd10; border: solid darken(@areia, 5%) 1px;
                box-shadow: 0px 0px 15px 5px rgba(0,0,0,.1); color: darken(@ceu, 10); .tc;
                i{ .t56; .cpao; }
                h3{ .t24; margin: 5px 0 10px; }
                p{ .t18; .lh140; }
            }
            @media (min-width: 768px) { grid-template-columns: 1fr 1fr; }
            @media (min-width: 1200px) { grid-template-columns: 1fr 1fr 1fr; }
        }
    }
    #produtos{
        margin-top: 20px; padding: 50px 0 100px;
        h2{
            .m0; margin-bottom: 40px; .tc; .uc; .t36; .cbranco;
        }
        .produto{
            display: grid;
            align-items: center; margin-bottom: 30px;
            img{
                width: 100%;
            }
            p{
                strong{ .t22; .cagua; }
                .cbranco; .t18; .lh160; text-wrap: balance;
            }
            @media(min-width: 768px){
                grid-template-columns: repeat(2, 1fr); .m0;
                p{ padding: 30px; .t24; strong{ .t32; } }
                &:nth-child(odd){
                    p{ order: 1; text-align: right; }
                    img{ order: 2; }
                }
            }
        }
    }
    #decoy{
        .bpao; padding: 50px 0;
        h3{
            .tc; .cbranco; .t36;
        }
    }
    #contato{
        .tc; .bareia; padding: 50px 0;

    }
}
</style>